import React from 'react';

function BarBoxItem(props) {
	return (
		<div className={`bar-box-item ${props.className ?? ''}`.trim()}>
			<h2 className="esri-font-demi bar-box-item-title">{props.title}</h2>
			<div className="bar-box-item-content">
				{props.icon && <div className="bar-box-item-content__icon">{props.icon}</div>}
				<div className="bar-box-item-content__message">{props.children}</div>
			</div>
		</div>
	);
}

export default BarBoxItem;
